import { ThemeProvider, createTheme } from '@mui/material/styles';
import { FC, PropsWithChildren, useMemo } from 'react';
import { useTheme } from '../colors.provider';

const ActionsDefaultThemeSnippet: FC<PropsWithChildren> = ({ children }) => {
  const { COLORS } = useTheme();

  const theme = useMemo(
    () =>
      createTheme({
        palette: {
          primary: {
            main: COLORS.primary.main,
          },
        },
        components: {
          MuiButton: {
            styleOverrides: {
              root: {
                '&.MuiButton-contained': {
                  color: COLORS.primary.contrast,
                  fontWeight: 'bold',
                },
                '&.MuiButton-text': {
                  color: COLORS.primary.main,
                  fontWeight: 'bold',
                },
              },
            },
          },
        },
      }),
    [COLORS]
  );

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};

export { ActionsDefaultThemeSnippet };
